import { Check } from "lucide-react";
import { AuthImage } from "./AuthImage";

export const TrackingTimeline = ({ tracking, resi, photoSrc }) => {
  const fmt = (iso) => iso ? new Date(iso).toLocaleString("id-ID", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "";
  const activeIdx = tracking.map((t) => t.done).lastIndexOf(true);
  return (
    <div className="relative pl-2" data-testid="tracking-timeline">
      {tracking.map((t, i) => {
        const isCurrent = i === activeIdx;
        const resiVal = resi?.[t.key];
        return (
          <div key={t.key} className="flex gap-4 pb-6 last:pb-0 relative">
            {i < tracking.length - 1 && (
              <div className={`absolute left-[15px] top-8 bottom-0 w-0.5 ${t.done ? "bg-emerald-500" : "bg-stone-200"}`} />
            )}
            <div className={`z-10 w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${t.done ? "bg-emerald-600 text-white" : "bg-stone-200 text-stone-400"} ${isCurrent ? "ring-4 ring-emerald-100" : ""}`}>
              {t.done ? <Check size={16} /> : <span className="w-2 h-2 rounded-full bg-current" />}
            </div>
            <div className="pt-1">
              <p className={`text-sm font-semibold ${t.done ? "text-stone-800" : "text-stone-400"}`}>{t.label}</p>
              {t.at && <p className="text-xs text-stone-400 font-mono">{fmt(t.at)}</p>}
              {resiVal && <p className="text-xs mt-0.5 font-mono text-emerald-700 bg-emerald-50 inline-block px-2 py-0.5 rounded" data-testid={`resi-${t.key}`}>No. Resi: {resiVal}</p>}
              {t.photos && t.photos.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2" data-testid={`stage-photos-${t.key}`}>
                  {t.photos.map((p, j) => photoSrc
                    ? <img key={j} src={photoSrc(p)} alt="Foto barang" className="w-20 h-20 rounded-lg object-cover border border-stone-200" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                    : <AuthImage key={j} path={p} className="w-20 h-20 rounded-lg object-cover border border-stone-200" />)}
                </div>
              )}
              {isCurrent && <span className="inline-block mt-1 text-[10px] font-bold uppercase tracking-wide text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full">Status Terkini</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
